var modules_8fa60410 = {"dropdown":"DesktopMenuDropdown_module_dropdown__c0d7047d","dropdownContent":"DesktopMenuDropdown_module_dropdownContent__c0d7047d","dropdownVisible":"DesktopMenuDropdown_module_dropdownVisible__c0d7047d","menuItem":"DesktopMenuDropdown_module_menuItem__c0d7047d"};
import "../../../assets/esm/components/DesktopMenu/src/DesktopMenuDropdown~D0EE8rvk.css";

export { modules_8fa60410 as default };
//# sourceMappingURL=DesktopMenuDropdown.module.less.js.map
